import React from 'react';
import { ApiEndpoint } from '../components/api/ApiEndpoint';
import { authenticationEndpoint } from '../data/apiData';

export const Authentication: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-10 pb-8 border-b border-gray-100">
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Authentication</h1>
        <p className="text-base text-gray-500 leading-relaxed max-w-2xl mb-6">
          The Aku API uses API key authentication to issue short-lived access tokens.
          Include the Bearer token in every subsequent request via the <code className="text-[#581689] bg-purple-50 px-1.5 py-0.5 rounded text-sm font-mono">Authorization</code> header.
        </p>

        <div className="space-y-4">
          <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-2.5">Authentication flow</h3>
            <ol className="space-y-1.5">
              {[
                'Log in to your Aku dashboard and navigate to the API Keys section.',
                'Copy your API key and client ID.',
                'Call the authentication endpoint with those credentials.',
                'Receive an access token in the response.',
                'Send the token as a Bearer token in all subsequent API requests.',
              ].map((step, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm text-gray-600">
                  <span className="shrink-0 mt-0.5 h-5 w-5 rounded-full bg-[#581689]/10 text-[#581689] text-xs font-bold flex items-center justify-center">
                    {i + 1}
                  </span>
                  {step}
                </li>
              ))}
            </ol>
          </div>

          <div className="border-l-4 border-amber-400 pl-4 py-1">
            <p className="text-sm text-gray-600">
              <span className="font-semibold text-gray-800">Important:</span> Access tokens are short-lived. Use the refresh token to obtain a new access token before it expires, and never commit API keys to version control.
            </p>
          </div>
        </div>
      </div>

      <ApiEndpoint endpoint={authenticationEndpoint} />
    </div>
  );
};
